import { createAction } from 'redux-act';

export const showAlreadyLoggedInNotice = createAction('Show already logged in notice');
export const closeAlreadyLoggedInNotice = createAction('Close already logged in notice');



// WEBPACK FOOTER //
// ./src/services/accountLink/accountLink.actions.ts